import { ListFieldsOptionsApiCall } from "@/app/api/types";
import { Entity, IField } from "@/app/fields/types";
import { BooleanFieldFilter } from "./BooleanFieldFilter";
import { DateFieldFilter } from "./DateFieldFilter";
import { NumberFieldFilter } from "./NumberFieldFilter";
import { SelectFieldFilter } from "./SelectFieldFilter";
import { UserFieldFilter } from "./UserFieldFilter";

export const FieldFilter = <T extends Entity>({
  field,
  getFieldOptions,
  isDisabled,
}: {
  field: IField<T>;
  getFieldOptions: ListFieldsOptionsApiCall;
  isDisabled: boolean;
}) => {
  switch (field.type) {
    case "boolean":
      return (
        <BooleanFieldFilter
          isDisabled={isDisabled}
          field={String(field.field)}
          label={field.label}
          true_filter_label={field.true_filter_label}
          false_filter_label={field.false_filter_label}
        />
      );
    case "number":
      return (
        <NumberFieldFilter
          isDisabled={isDisabled}
          field={String(field.field)}
          label={field.label}
        />
      );
    case "select":
      return (
        <SelectFieldFilter
          isDisabled={isDisabled}
          field={String(field.field)}
          label={field.label}
          getFieldOptions={getFieldOptions}
        />
      );
    case "user":
      return (
        <UserFieldFilter
          isDisabled={isDisabled}
          field={String(field.field)}
          label={field.label}
        />
      );
    case "date":
      return (
        <DateFieldFilter
          isDisabled={isDisabled}
          field={String(field.field)}
          label={field.label}
        />
      );
    default:
      throw new Error("Unknown field type");
  }
};
